export const AI_ERROR_MESSAGE_MAX_LENGTH = 1000;

const REDIS_COMMAND_MARKER = ", command was:";
const TRUNCATION_SUFFIX = "…";

/** Keep diagnostics useful without persisting provider request bodies with the error. */
export function getAiErrorMessage(error: unknown): string {
  const message =
    typeof error === "string"
      ? error
      : error && typeof error === "object" && "message" in error && typeof error.message === "string"
        ? error.message
        : "Unknown error";

  // Bound the input before searching: older requests can contain multi-megabyte snapshots.
  const preview = message.slice(0, AI_ERROR_MESSAGE_MAX_LENGTH + 1);
  const commandStart = preview.indexOf(REDIS_COMMAND_MARKER);
  if (commandStart >= 0) return preview.slice(0, commandStart).trim();
  if (message.length > AI_ERROR_MESSAGE_MAX_LENGTH) {
    return `${preview.slice(0, AI_ERROR_MESSAGE_MAX_LENGTH - TRUNCATION_SUFFIX.length)}${TRUNCATION_SUFFIX}`;
  }
  return preview;
}
